<div class="card card-custom">
  <div class="card-header">
    <div class="card-title">
      <h3 class="card-label">{{ getTitle() }}</h3>
    </div>
  </div>
  <form class="form form-group-seperator-dashed">
    <div class="card-body" style="height: 70vh; padding: 1%">
      <div>
        <div
          class="d-flex align-items-stretch border border-secondary rounded font-weight-bold p-2 m-2"
          *ngIf="actionType !== 'DOCUMENT_GENERATOR' && actionType !== 'MOVE_ACTIVITY_STEP'"
        >
          <div class="flex-grow-1 d-flex align-items-center">
            <div class="w-50 px-2">Payload Field</div>
            <div class="w-50 px-2">Value</div>
          </div>
        </div>
        <div *ngIf="actionType === 'CUSTOM_API'">
          <div
            *ngIf="!actionPayload"
            style="height: 80px !important"
            class="d-flex flex-center font-weight-bold"
          >
            No Fields Found!
          </div>
          <div
            *ngFor="let field of actionPayload"
            class="d-flex align-items-stretch border-bottom px-2 py-1 mb-1"
          >
            <div class="flex-grow-1 d-flex align-items-center">
              <div class="w-50 px-2">{{ field }}</div>
              <div class="w-50 px-2">
                <mat-form-field appearance="outline">
                  <mat-label>{{ field }} value</mat-label>
                  <textarea
                    matInput
                    [(ngModel)]="formData[field]"
                    [id]="field"
                    [ngModelOptions]="{ standalone: true }"
                    (keyup)="onKeyDown($event, field, 'custom')"
                    placeholder="Write something or type '{' to select from keys"
                  ></textarea>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div
            class="d-flex align-items-stretch border border-secondary rounded font-weight-bold p-2 m-2"
          >
            <div class="flex-grow-1 d-flex align-items-center">
              <div class="w-50 px-2">URL Payload Field</div>
              <div class="w-50 px-2">Value</div>
            </div>
          </div>
          <div
            *ngIf="!actionURLPayload"
            style="height: 80px !important"
            class="d-flex flex-center font-weight-bold"
          >
            No URL Fields Found!
          </div>
          <div
            *ngFor="let ufield of actionURLPayload"
            class="d-flex align-items-stretch border-bottom px-2 py-1 mb-1"
          >
            <div class="flex-grow-1 d-flex align-items-center">
              <div class="w-50 px-2">{{ ufield }}</div>
              <div class="w-50 px-2">
                <mat-form-field appearance="outline">
                  <mat-label>{{ ufield }} value</mat-label>
                  <textarea
                    matInput
                    required
                    #model="ngModel"
                    [(ngModel)]="formData[ufield]"
                    [id]="ufield"
                    [name]="ufield"
                    (keyup)="onKeyDown($event, ufield, 'custom')"
                    placeholder="Write something or type '{' to select from keys"
                  ></textarea>
                  <mat-error *ngIf="model.invalid && (model.touched || submitted)">
                    {{ ufield }} is required
                  </mat-error>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div
            *ngIf="showCustomFieldOptions"
            class="options-menu keys-menu"
            id="customKeysMenu"
            style="max-height: 280px !important; top: 25%; right: 10%"
          >
            <div
              *ngFor="let option of filteredFormFields"
              (click)="insertOption(option, this.selectedField, 'formData', 'custom')"
            >
              {{ option }}
            </div>
          </div>
        </div>
        <div *ngIf="actionType === 'FAX' || actionType === 'EMAIL'">
          <div class="d-flex align-items-stretch border-bottom px-2 py-1 mb-1">
            <div class="flex-grow-1 d-flex align-items-center">
              <div class="w-50 px-2">To</div>
              <div class="w-50 px-2">
                <mat-form-field appearance="outline">
                  <mat-chip-list #chipList>
                    <mat-chip
                      *ngFor="let selectedValue of toValues"
                      [removable]="true"
                      (removed)="removeToValue(selectedValue)"
                    >
                      {{ selectedValue }}
                      <mat-icon matChipRemove>cancel</mat-icon>
                    </mat-chip>
                  </mat-chip-list>
                  <mat-label>To</mat-label>
                  <input
                    matInput
                    [(ngModel)]="newToValue"
                    [ngModelOptions]="{ standalone: true }"
                    (keydown.enter)="onEnterKeyToAddToValue($event)"
                    (click)="$event.stopPropagation()"
                    [matChipInputFor]="chipList"
                    placeholder="Type and press enter"
                  />
                  <button
                    mat-icon-button
                    class="dropdown-btn-for-form-fields"
                    [matMenuTriggerFor]="dropdownMenu"
                  >
                    <mat-icon>arrow_drop_down</mat-icon>
                  </button>
                  <mat-menu #dropdownMenu="matMenu" class="form-options-menu">
                    <button mat-menu-item *ngFor="let key of formFields" (click)="addToValue(key)">
                      {{ key }}
                    </button>
                  </mat-menu>
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-stretch border-bottom px-2 py-1 mb-1">
            <div class="flex-grow-1 d-flex align-items-center">
              <div class="w-50 px-2">Subject</div>
              <div class="w-50 px-2">
                <mat-form-field appearance="outline">
                  <mat-label>Subject</mat-label>
                  <textarea
                    matInput
                    [(ngModel)]="subjectValue"
                    [ngModelOptions]="{ standalone: true }"
                    (keyup)="onKeyDown($event, null, 'subject')"
                    id="subjectTextArea"
                    placeholder="Write something or type '{' to select from keys"
                  ></textarea>
                </mat-form-field>
                <div *ngIf="showSubjectOptions" class="options-menu keys-menu" id="subjectKeysMenu">
                  <div
                    *ngFor="let option of filteredFormFields"
                    (click)="insertOption(option, 'subjectTextArea', null, 'subject')"
                  >
                    {{ option }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-stretch border-bottom px-2 py-1 mb-1">
            <div class="flex-grow-1 d-flex align-items-center">
              <div class="w-50 px-2">Body</div>
              <div class="w-50 px-2">
                <mat-form-field appearance="outline">
                  <mat-label>Body</mat-label>
                  <textarea
                    matInput
                    [(ngModel)]="bodyValue"
                    [ngModelOptions]="{ standalone: true }"
                    (keyup)="this.onKeyDown($event, null, 'body')"
                    id="bodyTextArea"
                    placeholder="Write something or type '{' to select from keys"
                  ></textarea>
                </mat-form-field>
                <div *ngIf="showBodyOptions" class="options-menu keys-menu" id="bodyKeysMenu">
                  <div
                    *ngFor="let option of filteredFormFields"
                    (click)="insertOption(option, 'bodyTextArea', null, 'body')"
                  >
                    {{ option }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="actionType === 'CREATE_TASK'">
          <div class="d-flex align-items-stretch border-bottom px-2 py-1 mb-1">
            <div class="flex-grow-1 d-flex align-items-center">
              <div class="w-50 px-2">Task Template</div>
              <div class="w-50 px-2">
                <kt-general-autocomplete
                  [appearance]="'outline'"
                  [label]="'Template'"
                  [loadItemsFunction]="templateAutocompleteCall"
                  [optionFormatter]="filterTemplateFn"
                  [valueFormatter]="filterTemplateFn"
                  [required]="true"
                  [readOnly]="false"
                  [control]="templateInput"
                  [change]="onTemplateChange.bind(this)"
                  [dataPath]="'data'"
                  [placeholder]="'Select Template'"
                  #templateAutocomplete
                >
                </kt-general-autocomplete>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="actionType === 'DOCUMENT_GENERATOR'">
          <div class="ks-d-flex ks-w-100 px-2">
            <div class="ks-w-50 ks-pr-4">
              <kt-autocomplete
                [id]="'template-field'"
                [color]="'neutral'"
                [label]="'Template'"
                [control]="getDocTemplateFormControl('documentTemplate')"
                [optionsType]="'API'"
                [optionsAPI]="getDocumentTemplatesAutocomplete$"
                [optionType]="'OBJECT'"
                [objectOptionReq]="{
                  idKey: 'id',
                  dataPath: 'data',
                  labelFormatter: formatFormTemplate,
                  valueFormatter: formatFormTemplate
                }"
                [errors]="[
                  { validation: 'required', message: 'Please select a document template' }
                ]"
              ></kt-autocomplete>
            </div>
            <div class="ks-w-50 ks-pl-4">
              <kt-autocomplete
                [id]="'category-field'"
                [color]="'neutral'"
                [label]="'Document Category'"
                [control]="getDocTemplateFormControl('documentCategory')"
                [optionsType]="'API'"
                [optionsAPI]="getCategoryAutocomplete$"
                [optionType]="'OBJECT'"
                [objectOptionReq]="{
                  idKey: 'id',
                  dataPath: 'data',
                  labelFormatter: formatCategory,
                  valueFormatter: formatCategory
                }"
                [errors]="[
                  { validation: 'required', message: 'Please select a document category' }
                ]"
              ></kt-autocomplete>
            </div>
          </div>
          <div
            class="d-flex align-items-stretch border border-secondary rounded font-weight-bold p-2 m-2"
            *ngIf="documentTemplatePayload.length > 0"
          >
            <div class="flex-grow-1 d-flex align-items-center">
              <div class="w-50 px-2">Payload Field</div>
              <div class="w-50 px-2">Value</div>
            </div>
          </div>
          <div class="w-100 px-2">
            <div
              *ngIf="!documentTemplatePayload"
              style="height: 80px !important"
              class="d-flex flex-center font-weight-bold"
            >
              No Keys Found!
            </div>
            <div
              *ngFor="let field of documentTemplatePayload"
              class="d-flex align-items-stretch border-bottom px-2 py-1 mb-1"
            >
              <div class="flex-grow-1 d-flex align-items-center">
                <div class="w-50 px-2">{{ field }}</div>
                <div class="w-50 px-2">
                  <mat-form-field appearance="outline">
                    <mat-label>{{ field }} value</mat-label>
                    <textarea
                      matInput
                      [(ngModel)]="formData[field]"
                      [id]="field"
                      [ngModelOptions]="{ standalone: true }"
                      (keyup)="onKeyDown($event, field, 'custom')"
                      placeholder="Write something or type '{' to select from keys"
                    ></textarea>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div
              *ngIf="showCustomFieldOptions"
              class="options-menu keys-menu"
              id="customKeysMenu"
              style="max-height: 280px !important; top: 25%; right: 10%"
            >
              <div
                *ngFor="let option of filteredFormFields"
                (click)="insertOption(option, this.selectedField, 'formData', 'custom')"
              >
                {{ option }}
              </div>
            </div>
          </div>
        </div>
        <main class="ks-card-body ks-scrollbar-neutral" *ngIf="actionType === 'DOCUMENT_GENERATOR'">
          <section class="ks-mb-10 ks-mt-5">
            <label class="ks-body-lg ks-font-weight-medium ks-pl-5"
              >Generated document options</label
            >
            <p class="ks-body-md ks-text-neutral ks-mb-6 ks-pl-5">
              By clicking on the checkbox, select the options you want to save or send the generated
              document.
            </p>
            <div class="ks-checkboxes-wrapper ks-px-15">
              <kt-checkbox
                *ngFor="let optionCtrl of getFormArrayControls('options'); let idx = index"
                [label]="documentTemplateSaveOptions[idx]?.label"
                [color]="'secondary'"
                [control]="optionCtrl"
              ></kt-checkbox>
            </div>
          </section>
          <section *ngIf="saveByEmailFax">
            <label class="ks-body-lg ks-font-weight-medium ks-pl-5">Email or fax details</label>
            <p class="ks-body-md ks-text-neutral ks-mb-6 ks-pl-5">
              By selecting send by email or fax options, subject and body fields are required.
            </p>
            <div class="ks-px-15">
              <div class="ks-w-75">
                <kt-input
                  [type]="'text'"
                  [label]="'Subject'"
                  [control]="getDocTemplateFormControl('subject')"
                  [errors]="[
                    { validation: 'required', message: 'Please add email or fax subject' }
                  ]"
                ></kt-input>
              </div>
              <kt-input
                [isTextarea]="true"
                [rows]="6"
                [label]="'Body'"
                [control]="getDocTemplateFormControl('body')"
                [errors]="[{ validation: 'required', message: 'Please add email or fax body' }]"
              ></kt-input>
            </div>
          </section>
        </main>
        <div *ngIf="actionType === 'MOVE_ACTIVITY_STEP'">
          <div class="d-flex align-items-stretch border-bottom px-2 py-1 mb-1 pb-5">
            <div class="flex-grow-1 d-flex align-items-center">
              <div class="w-50 px-2">Activity Template</div>
              <div class="w-50 px-2 template-form-field">
                <kt-general-autocomplete
                  [appearance]="'outline'"
                  [label]="'Activity Template'"
                  [loadItemsFunction]="activityTemplateAutocompleteCall"
                  [optionFormatter]="filterActivityTemplateFn"
                  [valueFormatter]="filterActivityTemplateFn"
                  [required]="true"
                  [readOnly]="false"
                  [control]="activityTemplateInput"
                  [change]="onActivityTemplateChange.bind(this)"
                  [dataPath]="'data'"
                  [placeholder]="'Select Activity Template'"
                  #activityTemplateAutocomplete
                >
                </kt-general-autocomplete>
              </div>
            </div>
          </div>
          <div class="d-flex align-items-stretch border-bottom px-2 py-1 mb-1">
            <div class="flex-grow-1 d-flex align-items-center">
              <div class="w-50 px-2">Step</div>
              <div class="w-50 px-2">
                <mat-form-field appearance="outline" class="full-width">
                  <mat-label>Step</mat-label>
                  <mat-select [formControl]="activityStepInput" [disabled]="!enableStepSelection">
                    <mat-option *ngFor="let option of activitySteps" [value]="option.id">
                      {{ option.name }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </form>
  <div class="card-footer" style="padding: 1%">
    <div class="d-flex justify-content-between">
      <div class="mr-2"></div>
      <div>
        <button (click)="close()" type="button" mat-raised-button matTooltip="Cancel">
          <span translate="GLOBAL.CANCEL">Cancel</span></button
        >&nbsp;
        <button
          type="button"
          mat-raised-button
          color="primary"
          (click)="onSubmit()"
          matTooltip="Save"
        >
          <span>Save</span>
        </button>
      </div>
    </div>
  </div>
</div>
